import './HomePage.scss';

import HeroBanner from '../../components/homepage/HeroBanner/HeroBanner';
import SectionCustomDesign from '../../components/homepage/SectionCustomDesign/SectionCustomDesign';
import SectionInstallationInfo from '../../components/homepage/SectionInstallationInfo/SectionInstallationInfo';
import SectionPromoBanner from '../../components/homepage/SectionPromoBanner/SectionPromoBanner';
import Tag from '../../components/common/Tag/Tag';
import SectionBasicModule from '../../components/homepage/SectionBasicModule/SectionBasicModule';
import { Trans, useTranslation } from 'react-i18next';
import ReactPlayer from 'react-player';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { fetchCampaigns } from '../../store/actions/campaign.action';
import { Icon } from '../../components/icon/icon';
import InputComponent from '../../components/common/InputComponent/InputComponent';
import ButtonPrimaryLarge from '../../components/common/ButtonPrimary/ButtonPrimaryLarge';

const HomePage = () => {
  const { t } = useTranslation();
  const [isReady, setIsReady] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchCampaigns());
  }, []);

  return (
    <div className="homepage flex flex-col gap-0 relative left-0 right-0">
      <HeroBanner />
      <section className="flex lg:flex-row flex-col-reverse items-center lg:gap-[40px] gap-[24px] self-stretch lg:py-[40px] lg:px-[80px] py-[32px] md:px-[20px] px-[16px] justify-center bg-white">
        {/* Left Video */}
        <div className="flex justify-end items-start grow self-stretch lg:h-[472.5px] md:h-[396px] h-[208.125px] rounded-[16px] border-[2px] border-solid border-outline-default-secondary overflow-hidden">
          <ReactPlayer
            src="https://www.youtube.com/watch?v=W2lemxIIMyk"
            width="100%"
            height="100%"
            playing={isReady}
            muted
            loop
            controls={false}
            playsInline
            onReady={() => setIsReady(true)}
            config={{
              youtube: {
                playerVars: {
                  autoplay: 1,
                  mute: 1,
                  loop: 1,
                  playlist: 'W2lemxIIMyk',
                },
              },
            }}
          />
        </div>

        {/* Right Description */}
        <div className="flex lg:w-[400px] w-full lg:p-[24px] p-[16px] flex-col justify-start items-start lg:gap-[24px] gap-[12px] self-stretch relative bg-fills-primary-varient lg:rounded-[24px] rounded-[16px] bg-lightgray/50">
          <span className="lg:text-headline-small md:text-headline-small text-title-large !font-bold">
            {t('Constant.Pioneering technology by Fitta')}
          </span>
          <span className="lg:text-body-large text-body-medium">
            <Trans
              i18nKey={
                'Constant.Allows you to easily create your own designs. Extremely affordable, it fits right into your budget.'
              }
              components={{
                highlight: <span className="text-primary-primary" />,
              }}
            />
          </span>
          <div className="flex flex-col justify-end items-end gap-[4px] absolute right-[25px] bottom-[25px]">
            <div className="flex justify-end items-center gap-[8px] self-stretch">
              <span className="flex lg:w-[16px] w-[7px] lg:h-[16px] h-[7px] aspect-square lg:rounded-[2px] rounded-[0.89px] bg-primary-secondary" />
            </div>
            <div className="flex justify-end items-center gap-[4px] self-stretch">
              <span className="flex lg:w-[16px] w-[7px] lg:h-[16px] h-[7px] aspect-square lg:rounded-[2px] rounded-[0.89px] bg-primary-secondary" />
              <span className="flex lg:w-[16px] w-[7px] lg:h-[16px] h-[7px] aspect-square lg:rounded-[2px] rounded-[0.89px] bg-primary-secondary" />
            </div>
          </div>
        </div>
      </section>
      <section className="flex lg:py-[40px] lg:px-[80px] py-[32px] md:px-[20px] px-[16px] flex-col items-center lg:gap-[40px] gap-[24px] self-stretch bg-white">
        <div className="flex flex-col items-start gap-[16px] self-stretch">
          <span className="lg:h1 text-headline-small !font-bold">
            <Trans
              i18nKey={'Constant.Factory-direct pricing. No Middleman'}
              components={{ br: <br /> }}
            />
          </span>
          <span className="lg:text-body-large text-body-medium">
            {t(
              'Constant.Design your own furniture - simple, flexible, and budget-friendly'
            )}
          </span>
        </div>
        <div className="grid grid-cols-1 grid-rows-2 lg:grid-rows-1 lg:grid-cols-2 gap-[16px] lg:gap-[40px] items-start justify-start self-stretch">
          <div className="grid grid-cols-2 items-start justify-start gap-[4px] self-stretch">
            <div className="flex self-stretch flex-col justify-start items-start lg:gap-[24px] gap-[16px] grow lg:rounded-[24px] rounded-[16px] bg-fills-primary-varient lg:p-[24px] p-[16px] -mr-[2px]">
              <Tag
                label={
                  <span className="lg:text-title-medium text-title-small !font-bold lg:h-[24px] h-[20px]">
                    01
                  </span>
                }
                className="rounded-[8px] text-white bg-primary-primary py-[4px] px-[8px] h-[32px]"
              />
              <div className="flex items-center justify-center lg:w-[48px] lg:h-[48px] w-[32px] h-[32px]">
                <Icon.ICDesign />
              </div>
              <span className="lg:text-title-large text-title-small">
                {t('Constant.No designer required')}
              </span>
            </div>
            <div className="flex self-stretch flex-col justify-start items-start lg:gap-[24px] gap-[16px] grow lg:rounded-[24px] rounded-[16px] bg-fills-primary-varient lg:p-[24px] p-[16px] -mr-[2px]">
              <Tag
                label={
                  <span className="lg:text-title-medium text-title-small !font-bold lg:h-[24px] h-[20px]">
                    02
                  </span>
                }
                className="rounded-[8px] text-white bg-primary-primary py-[4px] px-[8px] h-[32px]"
              />
              <div className="flex items-center justify-center lg:w-[48px] lg:h-[48px] w-[32px] h-[32px]">
                <Icon.ICPersonCustomize />
              </div>
              <span className="lg:text-title-large text-title-small">
                {t('Constant.No inventory — made to order.')}
              </span>
            </div>
            <div className="flex self-stretch flex-col justify-start items-start lg:gap-[24px] gap-[16px] grow lg:rounded-[24px] rounded-[16px] bg-fills-primary-varient lg:p-[24px] p-[16px] -mr-[2px]">
              <Tag
                label={
                  <span className="lg:text-title-medium text-title-small !font-bold lg:h-[24px] h-[20px]">
                    03
                  </span>
                }
                className="rounded-[8px] text-white bg-primary-primary py-[4px] px-[8px] h-[32px]"
              />
              <div className="flex items-center justify-center lg:w-[48px] lg:h-[48px] w-[32px] h-[32px]">
                <Icon.ICWarehouse />
              </div>
              <span className="lg:text-title-large text-title-small">
                {t('Constant.No middlemen — factory-direct.')}
              </span>
            </div>
            <div className="flex self-stretch flex-col justify-start items-start lg:gap-[24px] gap-[16px] grow lg:rounded-[24px] rounded-[16px] bg-fills-primary-varient lg:p-[24px] p-[16px] -mr-[2px]">
              <Tag
                label={
                  <span className="lg:text-title-medium text-title-small !font-bold lg:h-[24px] h-[20px]">
                    04
                  </span>
                }
                className="rounded-[8px] text-white bg-primary-primary py-[4px] px-[8px] h-[32px]"
              />
              <div className="flex items-center justify-center lg:w-[48px] lg:h-[48px] w-[32px] h-[32px]">
                <Icon.ICPrice />
              </div>
              <span className="lg:text-title-large text-title-small">
                {t('Constant.No budget surprises')}
              </span>
            </div>
          </div>
          <div
            className="flex items-center justify-center self-stretch h-[468px] lg:h-full rounded-[16px] bg-cover bg-fills-primary-varient"
            style={{
              backgroundImage:
                'url(https://d391nxox3m93fb.cloudfront.net/fitta_site_images/house.webp)',
            }}
          ></div>
        </div>
      </section>
      <SectionBasicModule />
      <SectionPromoBanner />
      <SectionCustomDesign />
      <SectionInstallationInfo />
      <section className="flex lg:py-[40px] lg:px-[80px] py-[32px] md:px-[20px] px-[16px] items-center lg:gap-[40px] gap-[24px] self-stretch bg-white">
        <div className="lg:h-fit h-[402px] sm:flex-row lg:flex-row md:flex-col grow flex items-start gap-[24px] self-stretch lg:rounded-[24px] rounded-[16px] bg-primary-primary relative overflow-hidden">
          <div className="flex z-10 lg:max-w-[700px] w-full lg:p-[40px] p-[16px] flex-col justify-start items-start gap-[24px] self-stretch">
            <span className="lg:text-headline-small text-title-medium !font-bold text-white">
              <Trans
                i18nKey={
                  'Constant.Stay updated with the latest information on products, features, and promotions from Fitta.'
                }
                components={{
                  highlight: <span className="text-[#FDC115]" />,
                }}
              />
            </span>
            <div className="flex items-start gap-[8px] self-stretch">
              <InputComponent
                placeholder={t('Input.Enter your email address')}
                className="grow"
                size="large"
              />
              <ButtonPrimaryLarge
                title={t('Subscribe')}
                className="bg-[#232323]"
              />
            </div>
            <span className="text-body-small text-white">
              {t(
                'Constant.By signing up, you agree to our Terms of Service and Privacy Policy.'
              )}
            </span>
          </div>
          <div className="lg:absolute  md:relative absolute right-0 bottom-0 flex flex-col justify-end items-end gap-[24px] grow self-stretch overflow-hidden">
            <div className="flex flex-col justify-end items-end gap-[4px] absolute right-[25px] bottom-[25px]">
              <div className="flex justify-end items-center gap-[8px] self-stretch">
                <span className="flex w-[16px] h-[16px] aspect-square rounded-[2px] bg-[#FDC115]" />
              </div>
              <div className="flex justify-end items-center gap-[4px] self-stretch">
                <span className="flex w-[16px] h-[16px] aspect-square rounded-[2px] bg-[#FDC115]" />
                <span className="flex w-[16px] h-[16px] aspect-square rounded-[2px] bg-[#FDC115]" />
              </div>
            </div>
            <div className="flex lg:w-[600px] md:w-full h-[250px] items-end justify-end">
              <img
                src="https://d391nxox3m93fb.cloudfront.net/fitta_site_images/footer.webp"
                className="object-right-top w-full h-full"
                alt=""
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default HomePage;
